import axiosInstance from "./axiosConfig";

class AssessmentServices {

  // Delete an assessment by ID
  static async deleteAssessment(assessmentId) {
    try {
      const response = await axiosInstance.delete(process.env.REACT_APP_API_URL+`/assessment/${assessmentId}`);
      return response;
    } catch (error) {
      console.error('Error deleting assessment:', error);
      throw error;
    }
  }

  static async deleteCriterion(assessmentId, criterionId) {
    try {
      const response = await axiosInstance.delete(process.env.REACT_APP_API_URL+`/criterion/${assessmentId}/${criterionId}`);
      return response;
    } catch (error) {
      console.error('Error deleting criterion:', error);
      throw error;
    }
  }

  static async deleteQuestion(assessmentId, questionId) {
    try {
      const response = await axiosInstance.delete(process.env.REACT_APP_API_URL+`/question/${assessmentId}/${questionId}`);
      return response;
    } catch (error) {
      console.error('Error deleting question:', error);
      throw error;
    }
  }

  static async deleteSection(assessmentId, sectionId) {
    try {
      const response = await axiosInstance.delete(process.env.REACT_APP_API_URL+`/section/${assessmentId}/${sectionId}`);
      return response;
    } catch (error) {
      console.error('Error deleting section:', error);
      throw error;
    }
  }

  // Read an assessment by ID
  static async getAssessment(assessmentId) {
    try {
      const response = await axiosInstance.get(process.env.REACT_APP_API_URL+`/assessment/${assessmentId}`);
      return response;
    } catch (error) {
      console.error('Error fetching assessment:', error);
      throw error;
    }
  }

  static async listAssessments(workspaceId) {
    try {
      const response = await axiosInstance.get(process.env.REACT_APP_API_URL+'/assessments/'+workspaceId);
      return response;
    } catch (error) {
      console.error('Error fetching assessments:', error);
      throw error;
    }
  }

  // Create a new assessment
  static async saveAssessment(assessmentData) {
    try {
      const response = await axiosInstance.put(process.env.REACT_APP_API_URL+'/assessment', assessmentData);
      return response;
    } catch (error) {
      console.error('Error creating assessment:', error);
      throw error;
    }
  }

  static async saveCriterion(assessmentId, criterionData) {
    try {
      const response = await axiosInstance.put(process.env.REACT_APP_API_URL+`/criterion/${assessmentId}`, criterionData);
      return response;
    } catch (error) {
      console.error('Error saving criterion:', error);
      throw error;
    }
  }

  static async saveInvitation(assessmentId, invitationData) {
    try {
      const response = await axiosInstance.put(process.env.REACT_APP_API_URL+`/invitation`, invitationData);
      return response;
    } catch (error) {
      console.error('Error saving invitation:', error);
      throw error;
    }
  }

  static async saveQuestion(assessmentId, questionData) {
    try {
      const response = await axiosInstance.put(process.env.REACT_APP_API_URL+`/question/${assessmentId}`, questionData);
      return response;
    } catch (error) {
      console.error('Error saving question:', error);
      throw error;
    }
  }

  static async saveSection(assessmentId, sectionData) {
    try {
      const response = await axiosInstance.put(process.env.REACT_APP_API_URL+`/section/${assessmentId}`, sectionData);
      return response;
    } catch (error) {
      console.error('Error saving section:', error);
      throw error;
    }
  }

}

export default AssessmentServices;
